export default __webpack_public_path__ + "static/media/Meal-Idea.4d46a89a.png";